import { Dispatch } from "redux";
import { setAttributeLabels, setAttributeLabelsLoading } from "@redux/actions/attribute-labels-actions";
import { FormattedAxnAttributeLabel, AxnAttributeType } from "@idw-types/data/reference-data/axn";
import { getAxnAttributeLabelsRequest } from "@requests/management-console/get-axn-attribute-labels";
import { formatAxnAttributeLabels } from "@formatters/axn-attribute-labels/axn-attribute-label-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getAttributeLabelsReduxRequest = (dispatch: Dispatch) => async (
    axnAttributeTypes: Array<AxnAttributeType>
): Promise<Array<FormattedAxnAttributeLabel>> => {
    dispatch(setAttributeLabelsLoading(true));
    const { data, error } = await getAxnAttributeLabelsRequest();
    if (data?.axnAttributeLabels) {
        const formattedAxnAttributeLabels = formatAxnAttributeLabels(data.axnAttributeLabels, axnAttributeTypes);
        dispatch(setAttributeLabels(formattedAxnAttributeLabels));
        return formattedAxnAttributeLabels;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAttributeLabels.error.title,
                resources.requests.getAttributeLabels.error.message
            );
        }
        dispatch(setAttributeLabelsLoading(false));
        return null;
    }
};